import React from "react";
import "./ContactComp.css";

const ContactComp = () => {
  return (
    <>
      <div className="container-map">
        <iframe
          frameBorder="0"
          scrolling=""
          marginHeight="0"
          marginWidth="0"
          width="100%"
          height="100%"
          src="https://maps.google.com/maps?key=YOUR_API_KEY&q=The%20Gentlemen%27s%20Lounge%20Longridge&t=m&z=14&output=embed&iwloc=near"
          title="Map showing The Gentlemen's Lounge Longridge"
          aria-label="The Gentlemen's Lounge Longridge"
        ></iframe>
      </div>
      <div className="contact-working">
        <div className="cont">
          <h3 id="contact">Contact</h3>
          <p>Address: </p>
          <p>99 Derby Road</p>
          <p>Longridge, Preston</p>
          <p>PR3 3EE, United Kingdom</p>
          <p>Phone: +44 7837 644389</p>
        </div>

        <div className="cont">
  <h3 id="opening">Opening Hours</h3>
  <table>
    <tbody>
      <tr>
        <th>Monday:</th>
        <td>10am–6pm</td>
      </tr>
      <tr>
        <th>Tuesday:</th>
        <td>10am–6pm</td>
      </tr>
      <tr>
        <th>Wednesday:</th>
        <td>10am–6pm</td>
      </tr>
      <tr>
        <th>Thursday:</th>
        <td>10am–7pm</td>
      </tr>
      <tr>
        <th>Friday:</th>
        <td>10am–6pm</td>
      </tr>
      <tr>
        <th>Saturday:</th>
        <td>9am–2pm</td>
      </tr>
      <tr>
        <th>Sunday:</th>
        <td>Closed</td>
      </tr>
    </tbody>
  </table>
</div>
      </div>
    </>
  );
};

export default ContactComp;
